import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./styles.css";
import Header from "../../components/Header/EduHeader";
import OuterFooter from "../../components/Footer/OuterFooter";

const CareersPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  const navigateToContactForm = (e) => {
    e.preventDefault();
    navigate('/', { state: { scrollToContact: true } });
  };

  return (
    <div className="careers-page">
      <Header />

      <section className="careers-hero-section">
        <div className="container">
          <div className="careers-hero-content">
            <span className="section-badge">JOIN OUR TEAM</span>
            <h1 className="careers-title">
              Build the <span className="highlight">Future of Education</span> with Us
            </h1>
            <p className="careers-subtitle">
              At Chanakya AI, we're transforming how students learn and how institutions teach.
              Join our mission to make personalized education accessible to all.
            </p>
            <a href="#current-openings" className="careers-cta-button">
              View Open Positions
            </a>
          </div>
        </div>
      </section>

      <section className="careers-mission-section">
        <div className="container">
          <div className="careers-mission-content">
            <div className="careers-mission-header">
              <span className="section-badge">OUR MISSION</span>
              <h2 className="section-title">Why Work With Us</h2>
              <p className="section-subtitle">
                We're building AI-driven solutions that help students learn better
                and institutions teach more effectively
              </p>
            </div>

            <div className="values-grid">
              <div className="value-card">
                <div className="value-icon-wrapper">
                  <svg
                    className="value-icon"
                    viewBox="0 0 24 24"
                    width="32"
                    height="32"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M18 8h1a4 4 0 0 1 0 8h-1"></path>
                    <path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"></path>
                    <line x1="6" y1="1" x2="6" y2="4"></line>
                    <line x1="10" y1="1" x2="10" y2="4"></line>
                    <line x1="14" y1="1" x2="14" y2="4"></line>
                  </svg>
                </div>
                <h3 className="value-title">Innovation First</h3>
                <p className="value-description">
                  We're constantly pushing the boundaries of what AI can do in education, 
                  experimenting with new ideas and approaches.
                </p>
              </div>

              <div className="value-card">
                <div className="value-icon-wrapper">
                  <svg
                    className="value-icon"
                    viewBox="0 0 24 24"
                    width="32"
                    height="32"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                    <circle cx="9" cy="7" r="4"></circle>
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                  </svg>
                </div>
                <h3 className="value-title">Collaborative Culture</h3>
                <p className="value-description">
                  We work together across teams, combining our diverse skills and 
                  perspectives to create the best possible solutions.
                </p>
              </div>

              <div className="value-card">
                <div className="value-icon-wrapper">
                  <svg
                    className="value-icon"
                    viewBox="0 0 24 24"
                    width="32"
                    height="32"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M12 20h9"></path>
                    <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>
                  </svg>
                </div>
                <h3 className="value-title">Learning & Growth</h3>
                <p className="value-description">
                  We invest in our team's development, providing opportunities to learn new skills, 
                  take on challenging projects, and grow professionally.
                </p>
              </div>

              <div className="value-card">
                <div className="value-icon-wrapper">
                  <svg
                    className="value-icon"
                    viewBox="0 0 24 24"
                    width="32"
                    height="32"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                  </svg>
                </div>
                <h3 className="value-title">Impact-Driven</h3>
                <p className="value-description">
                  Everything we do is focused on creating meaningful impact for students 
                  and educational institutions across India and beyond.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="careers-perks-section">
        <div className="container">
          <div className="careers-perks-content">
            <div className="careers-perks-header">
              <span className="section-badge">BENEFITS</span>
              <h2 className="section-title">Why You'll Love Working Here</h2>
              <p className="section-subtitle">
                We offer competitive compensation and a range of benefits designed to support 
                your work and life
              </p>
            </div>

            <div className="perks-grid">
              <div className="perk-card">
                <div className="perk-icon-wrapper">
                  <svg
                    className="perk-icon"
                    viewBox="0 0 24 24"
                    width="32"
                    height="32"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
                    <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
                  </svg>
                </div>
                <h3 className="perk-title">Flexible Work</h3>
                <p className="perk-description">
                  Remote-friendly with flexible hours to help you work when and where you're most productive.
                </p>
              </div>

              <div className="perk-card">
                <div className="perk-icon-wrapper">
                  <svg
                    className="perk-icon"
                    viewBox="0 0 24 24"
                    width="32"
                    height="32"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle cx="12" cy="12" r="10"></circle>
                    <path d="M12 6v6l4 2"></path>
                  </svg>
                </div>
                <h3 className="perk-title">Work-Life Balance</h3>
                <p className="perk-description">
                  We respect your personal time with reasonable working hours and generous leave policies.
                </p>
              </div>

              <div className="perk-card">
                <div className="perk-icon-wrapper">
                  <svg
                    className="perk-icon"
                    viewBox="0 0 24 24"
                    width="32"
                    height="32"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
                  </svg>
                </div>
                <h3 className="perk-title">Career Development</h3>
                <p className="perk-description">
                  Opportunities for professional growth, learning stipends, and regular mentorship.
                </p>
              </div>


              <div className="perk-card">
                <div className="perk-icon-wrapper">
                  <svg
                    className="perk-icon"
                    viewBox="0 0 24 24"
                    width="32"
                    height="32"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
                  </svg>
                </div>
                <h3 className="perk-title">Latest Tech</h3>
                <p className="perk-description">
                  Access to cutting-edge technologies and the tools you need to do your best work.
                </p>
              </div>

              <div className="perk-card">
                <div className="perk-icon-wrapper">
                  <svg
                    className="perk-icon"
                    viewBox="0 0 24 24"
                    width="32"
                    height="32"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"></path>
                  </svg>
                </div>
                <h3 className="perk-title">Team Events</h3>
                <p className="perk-description">
                  Regular team building activities, retreats, and celebrations to foster connections.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="current-openings" className="careers-openings-section">
        <div className="container">
          <div className="careers-openings-content">
            <div className="careers-openings-header">
              <span className="section-badge">OPEN ROLES</span>
              <h2 className="section-title">Current Openings</h2>
              <p className="section-subtitle">
                Join our team and help shape the future of AI-powered education
              </p>
            </div>

            <div className="job-listings">
              <div className="job-card">
                <div className="job-header">
                  <h3 className="job-title">AI/ML Intern – Agentic Frameworks</h3>
                  <span className="job-type">Internship (3-6 months)</span>
                </div>
                <div className="job-location">
                  <span className="location-badge">Remote / Hybrid</span>
                </div>
                <p className="job-description">
                  We're looking for a passionate and driven AI/ML Intern to work on next-generation AI systems 
                  involving agentic frameworks. You'll collaborate with our core AI team to design and implement 
                  intelligent agents that can autonomously reason, retrieve information, interact with tools, 
                  and execute tasks across a range of domains.
                </p>
                <div className="job-requirements">
                  <h4>Key Responsibilities</h4>
                  <ul className="requirements-list">
                    <li>Assist in designing and implementing agent workflows for task automation</li>
                    <li>Integrate LLMs into pipelines using APIs like OpenAI, Together AI, or Hugging Face models</li>
                    <li>Work with vector databases to enable retrieval-augmented generation (RAG)</li>
                    <li>Contribute to prompt engineering and agent memory handling</li>
                    <li>Debug, test, and optimize multi-agent systems</li>
                  </ul>
                </div>
                <div className="job-requirements">
                  <h4>Required Skills</h4>
                  <ul className="requirements-list">
                    <li>Strong Python programming skills with understanding of modern AI/ML toolchains</li>
                    <li>Familiarity with LangChain, LangGraph, or AutoGen</li>
                    <li>Experience working with LLMs and API integration</li>
                    <li>Basic understanding of RAG systems and knowledge graphs is a plus</li>
                    <li>Clear grasp of prompt engineering concepts and agent loops</li>
                  </ul>
                </div>
                <div className="job-requirements">
                  <h4>What You'll Gain</h4>
                  <ul className="requirements-list">
                    <li>Practical experience in cutting-edge AI/LLM applications</li>
                    <li>Mentorship from experienced engineers and researchers</li>
                    <li>Opportunity to publish or open-source your work (if applicable)</li>
                    <li>Certificate and potential pre-placement offer (PPO) based on performance</li>
                  </ul>
                </div>
                <a href="apply" onClick={navigateToContactForm} className="apply-button">
                  Apply Now
                </a>
              </div>
            </div>

            <div className="careers-contact-box">
              <h3>Don't see a role that fits?</h3>
              <p>
                We're always looking for talented individuals to join our team. 
                Send us your resume and we'll keep you in mind for future opportunities.
              </p>
              <a href="contact" onClick={navigateToContactForm} className="contact-button">
                Contact Us
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="careers-cta-section">
        <div className="container">
          <div className="careers-cta-content">
            <h2>Ready to make an impact in education?</h2>
            <p>Join our team and help shape the future of learning with AI</p>
            <a href="#current-openings" className="careers-cta-button">
              View Open Positions
            </a>
          </div>
        </div>
      </section>

      <OuterFooter />
    </div>
  );
};

export default CareersPage;